import FieldbookPesticides from './FieldbookFertilizations'

export default FieldbookPesticides
